// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  clientId: "ebb0bc239bec425091ab08049e68d58e",
  secret: "8QZUHPfbgqHRpQfQxGCH7gnrXyzi28j7",
  token: "USpQ0V8AKPg9fTLF4mrheQ3BVS6DrYDY5k",
  version: "0.5 beta",
  Locale: "fr_FR",
  Region : "eu"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
